import { useCallback, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import EditCardTabs from '../../../../../../../baseComponents/EditCardTabs'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { getBasePath } from '../../../../../../../utils/globals/link'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { setVariablesToCurrentPage } from '../../../../../../../utils/reducers/reduxDispatch'
import FeaturesProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/FeaturesProduct'
import ProductAddon from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/ProductAddon'
import ProductComposed from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/ProductComposed'
import SeoProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SeoProduct'
import SpecificPricesProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SpecificPricesProduct'
import SuppliersProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/SuppliersProduct'
import VariantsProduct from '../../../../../../../specificComponents/Product/ProductLayout/Tabs/VariantsProduct'
import { ProductExtendedTyShort } from '../../../../../../../specificComponents/Product/types'
import { getProductName, parseSelectedCategories } from '../../Products/SingleProduct/function'
import OtherInformationService from './Tabs/OtherInformationService'
import MainService from './Tabs/MainService'
import WrapperProductTabs from '../../../../../../../specificComponents/Product/ProductLayout/Subcomponents/WrapperProductTabs'
import { getConfigParam } from '../../../../../../../utils/reducers/getters'
import StockService from './Tabs/StockService'

type SingleServiceProps = SingleServiceLogicProps & ComponentWithPermissions & {}

const SingleService: React.FC<SingleServiceProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const { basicData, getData } = useSingleServiceLogic({ params })
    if (!params.id) {
        return null
    }
    const operateStockServices = getConfigParam('operateStockServices')
    const tabs: ComponentTabObject = {
        'main': { component: MainService, text: t('general', 'General'), permission: 'product.service.main' },
        'stock': { component: StockService, text: t('stock', 'Inventario'), permission: 'product.service.main', hideTab: basicData?.operateStock === 'on' || (!basicData?.operateStock && operateStockServices === 'on')? false : true },
        'prices': { component: SpecificPricesProduct, text: t('prices', 'Precios'), permission: 'product.service.specificPrice' },
        'variants': { component: VariantsProduct, text: t('variants', 'Variantes'), permission: 'product.service.variant' },
        'product-addon': { component: ProductAddon, text: t('addons', 'Complementos'), permission: 'product.service.productAddon' },
        'product-composed': { component: ProductComposed, text: t('productComposed', 'Producto Compuesto'), permission: 'product.service.productComposed' },
        'suppliers': { component: SuppliersProduct, text: t('suppliers', 'Proveedores'), permission: 'product.service.supplier'},
        'features': { component: FeaturesProduct, text: t('features', 'Características'), permission: 'product.service.features' },
        'other-information': { component: OtherInformationService, text: t('otherInformation', 'Otra información'), permission: 'product.service.otherInformation' },
        'web': { component: SeoProduct, text: t('webShort', 'Web'), permission: 'product.service.web' },
    }
    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} Wrapper={WrapperProductTabs} />)
}

interface SingleServiceLogicProps {
    params: { id?: string, tab?: string }
}


const useSingleServiceLogic = ({ params }: SingleServiceLogicProps) => {
    const [basicData, setBasicData] = useState<ProductExtendedTyShort | null>(null)
    const id = params.id

    const getData = useCallback(async () => {
        const myData: ProductExtendedTyShort = await twinFetchPostJSON('/api/app/product/getProductInstanceComplete', {
            id,
        })
        if (myData) {
            myData['parsedCategories'] = parseSelectedCategories(myData?.CategoriesProducts)
            myData['name'] = getProductName(myData.ProductLangs)
            setBasicData(myData)
            setVariablesToCurrentPage([myData['name']])
        }
    }, [setBasicData, id])

    useEffect(() => {
        setBasicData(null)
        getData()
    }, [getData])

    return { basicData, getData }
}

export default SingleService